export enum ExpertRole {
    Nutritionist = "nutritionist",
    Specialist = "specialist",
    Admin = "admin",
    Physician = "physician",
    Psychologist = "psychologist",
}